"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecordingSLI = void 0;
var _useCommonPageActionsApi = require("../../client/react/useCommonPageActionsApi");
var _useCustomPageActionApi = require("../../client/useCustomPageActionApi");
var useRecordingSLI = exports.useRecordingSLI = function useRecordingSLI() {
  var _useCommonPageActions = (0, _useCommonPageActionsApi.useCommonPageActionsApi)(),
    recordingStartedWorkflow = _useCommonPageActions.recordingStartedWorkflow,
    recordingStoppedWorkflow = _useCommonPageActions.recordingStoppedWorkflow;
  var _useCustomPageActions = (0, _useCustomPageActionApi.useCustomPageActionsApi)(),
    startRecordingStartWorkflow = _useCustomPageActions.startRecordingStartWorkflow,
    endRecordingStartWorkflow = _useCustomPageActions.endRecordingStartWorkflow,
    startRecordingStopWorkflow = _useCustomPageActions.startRecordingStopWorkflow,
    endRecordingStopWorkflow = _useCustomPageActions.endRecordingStopWorkflow;

  /**
   * This function is used to start the Start Recording SLI when the Start or Start all button is clicked.
   * @param {string} recordingId - The id of recording that was started
   * @returns {void}
   */
  var startRecordingStartSLI = function startRecordingStartSLI(payload) {
    startRecordingStartWorkflow(payload);
    recordingStartedWorkflow(payload);
  };

  /**
   * This function is used to end the Start Recording SLI when the recording started succeeded or failed.
   * @param {string} recordingId - The id of recording that was started
   * @returns {void}
   */
  var startRecordingEndSLI = function startRecordingEndSLI(payload) {
    endRecordingStartWorkflow(payload);
  };

  /**
   * This function is used to start the Stop Recording SLI when the Stop or Stop all button is clicked.
   * @param {string} recordingId - The id of recording that was started
   * @returns {void}
   */
  var stopRecordingStartSLI = function stopRecordingStartSLI(payload) {
    startRecordingStopWorkflow(payload);
    recordingStoppedWorkflow(payload);
  };

  /**
   * This function is used to end the Stop Recording SLI when the recording stopped succeeded or failed.
   * @param {string} recordingId - The id of recording that was started
   * @returns {void}
   */
  var stopRecordingEndSLI = function stopRecordingEndSLI(payload) {
    endRecordingStopWorkflow(payload);
  };
  return {
    startRecordingStartSLI: startRecordingStartSLI,
    startRecordingEndSLI: startRecordingEndSLI,
    stopRecordingStartSLI: stopRecordingStartSLI,
    stopRecordingEndSLI: stopRecordingEndSLI
  };
};